import { useContext, createContext } from 'react';
import RestaurantDto from '../models/RestaurantDto';
import { useState } from 'react';
import { PropsWithChildren } from 'react';
import { TokenFields } from '../tools/Tools';
import { useSessionStorageState } from '../hooks/useSessionStorageState';

const initialState: RestaurantDto = RestaurantDto.prototype;

interface RestaurantDataContextInterface {
  restaurantData: RestaurantDto,
  setRestaurantData: (restaurant: RestaurantDto) => void,
  table: number,
  setTable: (table: number) => void,
  token: string,
  decodedToken?: TokenFields,
  setToken: (token: string) => void,
  setDecodedToken: (decodedToken?: TokenFields) => void,
  sessionId: string;
  setSessionId: (sessionId: string) => void;
  expired: Date;
  setExpired: (expired: Date) => void;
  live: boolean;
  setLive: (live: boolean) => void;
}

const RestaurantDataContext = createContext<RestaurantDataContextInterface>({ live: false, setLive: () => { }, expired: new Date(), setExpired: () => { }, sessionId: '', setSessionId: () => { }, decodedToken: undefined, setDecodedToken: () => { }, token: '', setToken: () => { }, table: 0, setTable: () => { }, restaurantData: RestaurantDto.prototype, setRestaurantData: () => { } });

export const useRestaurantData = () => useContext(RestaurantDataContext);

export function RestaurantDataProvider(props: PropsWithChildren<{}>) {
  const [restaurantData, setRestaurantData] = useState(initialState);
  const [table, setTable] = useSessionStorageState<number>('qr-menu.table', 0);
  const [sessionId, setSessionId] = useSessionStorageState<string>('qr-menu.sessionId', '');
  const [expired, setExpired] = useSessionStorageState<Date>('qr-menu.expired', new Date(), true);
  const [token, setToken] = useState<string>('');
  const [live, setLive] = useState<boolean>(false);
  const [decodedToken, setDecodedToken] = useState<TokenFields | undefined>(undefined);

  const value = { live, setLive, expired, setExpired, sessionId, setSessionId, decodedToken, setDecodedToken, restaurantData, setRestaurantData, table, setTable, token, setToken };

  return <RestaurantDataContext.Provider value={value} {...props} />;
}
